
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[city]/personal/ipoteka-dlya-nerezidentov",
      function () {
        return require("private-next-pages/[city]/personal/ipoteka-dlya-nerezidentov.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[city]/personal/ipoteka-dlya-nerezidentov"])
      });
    }
  